import React, { useState, useEffect, useCallback } from "react";
import { Card, Row, Col, Statistic, Table, message, Spin, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import PageHeader from "../Layout/PageHeader";

const RedemptionReport = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchReport = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/redemption-report");
      setData(res.data.data);
    } catch (error) {
      message.error(error.response?.data?.message || error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchReport();
  }, [fetchReport]);

  const monthlyColumns = [
    { title: "Month (Asia/KL)", dataIndex: "monthKey", key: "monthKey", width: 140 },
    { title: "Points redeemed", dataIndex: "pointsRedeemed", key: "pointsRedeemed", width: 160 },
    { title: "RM equivalent", dataIndex: "rm", key: "rm", width: 140, render: (v) => `RM${v}` },
  ];

  const topColumns = [
    { title: "Item", dataIndex: "name", key: "name" },
    { title: "Redemption count", dataIndex: "count", key: "count", width: 160 },
    { title: "Points redeemed", dataIndex: "pointsRedeemed", key: "pointsRedeemed", width: 160 },
  ];

  return (
    <div>
      <PageHeader
        title="Redemption Report"
        childRoutes={[{ path: "/redemption-report", breadcrumbName: "Redemption Report" }]}
      />

      <Spin spinning={loading}>
        <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
          <Col xs={24} sm={12}>
            <Card>
              <Statistic
                title={
                  <span>
                    Outstanding points{" "}
                    <Tooltip title="Outstanding = (Earn + Refund) − (Redeem + Expired) = Σ EARN − Σ REDEEM. Refunds are compensating EARN rows and expiries are REDEEM rows, so both are already captured in the EARN/REDEEM totals. Equals the sum of every user's point balance.">
                      <InfoCircleOutlined />
                    </Tooltip>
                  </span>
                }
                value={data?.outstandingPoints || 0}
                suffix="pts"
              />
            </Card>
          </Col>
          <Col xs={24} sm={12}>
            <Card>
              <Statistic
                title="Liability (RM, at 200pt = RM1)"
                value={data?.liabilityRM || 0}
                prefix="RM"
                precision={2}
              />
            </Card>
          </Col>
        </Row>

        <Card title="Monthly redemption volume (last 6 months)" style={{ marginBottom: 16 }}>
          <Table
            rowKey="monthKey"
            columns={monthlyColumns}
            dataSource={data?.monthlyRedemptionVolume || []}
            pagination={false}
            size="small"
          />
        </Card>

        <Card title="Top redeemed items this month">
          <Table
            rowKey="rewardItemId"
            columns={topColumns}
            dataSource={data?.topItems || []}
            pagination={false}
            size="small"
          />
        </Card>
      </Spin>
    </div>
  );
};

export default RedemptionReport;
